// Borrowed from https://github.com/gregberge/react-flatten-children/blob/af9d1785ae80bb13254d2e77d003833ea6483dd9/src/index.tsx
import * as React from 'react';
function flattenChildren(children) {
  const childrenArray = React.Children.toArray(children);
  return childrenArray.reduce((flatChildren, child) => {
    if (child.type === React.Fragment) {
      return flatChildren.concat(flattenChildren(child.props.children));
    }
    flatChildren.push(child);
    return flatChildren;
  }, []);
}
export default flattenChildren;